module.exports = __webpack_public_path__ + "img/jhmobm15.96388395.png";